/**
 * Time functions for date and time manipulation
 */

/**
 * Get AM/PM indicator for a given date
 * @param {Date} date - The date object
 * @returns {string} - 'AM' or 'PM'
 */
export const getAmPm = (date) => {
  if (!(date instanceof Date) || isNaN(date.getTime())) {
    throw new Error('Invalid date provided');
  }
  return date.getHours() < 12 ? 'AM' : 'PM';
};

/**
 * Get 12-hour format hour for a given date
 * @param {Date} date - The date object
 * @returns {number} - Hour in 12-hour format (1-12)
 */
export const get12HourFormat = (date) => {
  if (!(date instanceof Date) || isNaN(date.getTime())) {
    throw new Error('Invalid date provided');
  }
  return date.getHours() % 12 || 12;
};
